import {
  GuideFaucet,
  GuideValve,
  GuideEmpty,
  GuideSink,
} from "@/components/VisualSearch/v1/CameraView/icons"

export const getGuide = (category, content) => {
  const { faucetGuide, toiletGuide, volveGuide, sinkGuide, defaultGuide } =
    content
  switch (category?.toLowerCase()) {
    case "faucets":
      return {
        image: <GuideFaucet />,
        text: faucetGuide,
      }
    case "toilet":
      return {
        image: <GuideEmpty />,
        text: toiletGuide,
      }
    case "valve":
      return { image: <GuideValve />, text: volveGuide }
    case "sinks":
      return { image: <GuideSink />, text: sinkGuide }
    case "shower":
      return { image: <GuideEmpty />, text: defaultGuide }
    default:
      return {
        image: <GuideEmpty />,
        text: defaultGuide,
      }
  }
}
